module.exports = __webpack_public_path__ + "img/2.f837cfa6.jpg";